export async function loadAnalyticsTimeZones(venueId, token, signal) {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/private/analysis/content/log/summary/read`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ venue_id: venueId, timeZonesOnly: true }), signal,
    });
    const data = await response.json();
    if (!response.ok || !Array.isArray(data?.timeZones)) throw new Error('Unable to load reporting time zones. Please retry.');
    const names = [...new Set(data.timeZones.filter(name => {
        if (typeof name !== 'string') return false;
        try { new Intl.DateTimeFormat('en', { timeZone: name }).format(); return true; }
        catch (_) { return false; }
    }))].sort();
    if (!names.length) throw new Error('No compatible reporting time zones are available.');
    return names;
}
